import { getAccessToken } from "api/baseApi";
import { api } from "api/enhancedEndpoints";
import { useDispatch } from "react-redux";
import { useGetApiConfigQuery } from "api/generatedApi";

export function UploadDocument(path: string, maxFileSizeMb?: number) {
  const dispatch = useDispatch();
  const { data: configData } = useGetApiConfigQuery();

  const maxFileSizeBytes = (maxFileSizeMb ?? configData?.maxUploadFileSizeMB ?? 25) * 1024 * 1024;

  const clickUploadDocument = async (file: File, dynamicPath?: string): Promise<string | undefined> => {
    const url = dynamicPath ?? path;

    const fileObj = file;

    if (!fileObj) return undefined;

    const uploadDocumentFormData = new FormData();
    uploadDocumentFormData.append("file", fileObj);

    if (fileObj.size > maxFileSizeBytes) {
      throw new RangeError();
    }

    // reset file input

    const token = await getAccessToken();
    const uploadedFilename = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: uploadDocumentFormData,
    })
      .then((response) => {
        if (response.ok) return response.json;
        throw new Error();
      })
      .then(() => {
        dispatch(api.util.invalidateTags(["Folders"]));
        return fileObj.name;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
    return uploadedFilename;
  };

  return clickUploadDocument;
}
